'use strict';
var util = require('../../util');

/**
 * @description Updates main product price considering recommended items price
 */
function updateMainPrice() {
	var mainProductPrice = $('.product-detail .price-sales').first();
	var initialPriceEl = mainProductPrice.siblings('input[name="price"]');
	var mainPriceNumber = +initialPriceEl.val();
	var selectedRecommendations = $('.cross-sell-recommendations').find('.recommendation-item.selected');
	selectedRecommendations.each(function() {
		var recommendedPrice = $(this).find('input[name="price"]');
		mainPriceNumber += +recommendedPrice.val();
	});
	// update new price format with currency
	var newPriceFormatted = util.getFormattedPrice(mainPriceNumber);
	mainProductPrice.html(newPriceFormatted);
}

function setNewPrice(priceElement, price, quantity) {
	var newPrice = price.val() * quantity.val();
	var newPriceFormatted = util.getFormattedPrice(newPrice);
	priceElement.html(newPriceFormatted);
	price.val(newPrice);
}

/**
 * @description Updates recommended items price value considering its quantity
 */
function updateRecommendedItemsPrice() {
	var recommendations = $('.cross-sell-recommendations').find('.recommendation-item');
	recommendations.each(function() {
		var quantity = $(this).find('input[name="quantity"]');
		if (!quantity.length) {
			return;
		}

		var priceSalesWrapper = $(this).find('.price-sales');
		var priceSales = $(this).find('input[name="price"]');
		setNewPrice(priceSalesWrapper, priceSales, quantity);

		var priceStandardEl = $(this).find('.price-standard');
		var priceStandard = $(this).find('input[name="priceStandard"]');
		if (priceStandardEl.length && priceStandard.length) {
			setNewPrice(priceStandardEl, priceStandard, quantity);
		}
	});
}


exports.init = function () {
	var recommendations = $('.cross-sell-recommendations');

	if (recommendations.find('.recommendation-item').length > 2) {
		recommendations.find('#recommendations-carousel').slick({
			slidesToShow: 3,
			infinite: false,
			responsive: [{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2
				}
			}, {
				breakpoint: 768,
				settings: {
					slidesToShow: 3
				}
			}]
		});
	}

	updateRecommendedItemsPrice();

	updateMainPrice();

	recommendations.on('click', '.recommendation-item', function () {
		$(this).toggleClass('selected');
		updateMainPrice();
	});
};
